import React from 'react';
import style from './NCT.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function NCT(props) {
  return (
    <div className={style.NCT}>
      <Head>
        <title>NERC Compliance Testing | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a>E&#178; Engineering Services</a></Link></li>
        <span>/</span>
        <li><Link href={'/e2-engineering-services/onsite-services'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> Onsite Services</a></Link></li>
        <span>/</span>
      </div>
      <h3>NERC Compliance Testing</h3>
      <p>NERC was established to create policies to help ensure the reliability of the bulk power generated in North America. The NERC policies provide guidelines for reporting machine availability, generator system testing and verification of models and performance of synchronous machines.</p>
      <p>Standards are either currently in place or are being developed by regional councils to meet North American Electric Reliability Corporation (NERC) standards, requiring baseline and periodic (every 5 years) testing and verification of power plant models for units greater than 10 MVA.</p>
      <p>NERC Required Information:</p>
      <div>
        <ul>
          <li>Unit reactive capability</li>
          <li>Excitation system model</li>
          <li>Generator characteristics</li>
          <li>Operation & model of excitation limiters</li>
          <li>Calibration & coordination of generator protection relays</li>
          <li>Automatic voltage regulator control</li>
          <li>Operation & model of power system stabilizers</li>
          <li>Governor droop & deadband</li>
        </ul>
      </div>
      <p>Reliability is the primary concern. To be able to predict the overall system response and reliability, NERC needs to know the capabilities of the generating system and the anticipated performance for both steady state operation and during system transients caused by loss of generation, faults, or other types of disturbances.</p>
      <p>This requires that the generator, excitation system, turbine governor, overexcitation limiter and power system stabilizer parameters be verified through comparison of simulated dynamic responses to field test measurements.</p>
      <p>Basler Services provides NERC compliance testing of generator control, protection and excitation systems including:</p>
      <div>
        <ul>
          <li>Onsite testing and verification of your systems</li>
          <li>Compilation of data and modeling information</li>
          <li>Confirmation on the proper operation of equipment</li>
          <li>Calibration testing of protective relays</li>
          <li>Tuning and testing of the Power System Stabilizer (PSS)</li>
          <li>Final report including short- and long-term recommendations and report prep for submittal to NERC</li>
        </ul>
      </div>
      <p>NERC compliance testing includes the following general work scope:</p>
      <div>
        <ol style={{listStyleType: "upper-alpha"}}>
          <li>Testing of the auto voltage regulator</li>
          <ol>
            <li>Tuning & step response of AVR</li>
            <li>Tuning & dynamic performance testing of all limiters (Overexcitation, underexcitation, volts per hertz, etc.)</li>
          </ol>
          <li>System model verification test</li>
          <ol>
            <li>Saturation curve tests to determine air gap saturation characteristics</li>
            <li>Unit trip with 0 MW / 20% leading VARs in AVR mode to determine excitation system parameters</li>
            <li>Unit trip in manual VR mode to estimate internal unit reactance</li>
            <li>Generator trip @ 10% MW to determine inertia constant and governor performance</li>
          </ol>
          <li>Online verification of generator leading & lagging reactive capability</li>
          <li>Calibration testing of protective relays</li>
          <li>Tuning & testing of the power system stabilizer</li>
          <li>Report prep for submittal to NERC</li>
        </ol>
      </div>
      <p>Call Basler Services to discuss the NERC compliance testing needs for your generating system. We perform these engineering services independent of all system equipment manufacturers. References provided upon request.</p>
      <Link href={"/contact-us"}><a className={`${style.cta} ${style.primaryCta}`}>Contact Us <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      <a className={`${style.cta} ${style.primaryCta}`} href="https://www.nerc.com/pa/stand/Pages/ReliabilityStandardsUnitedStates.aspx?jurisdiction=United%20States">More About NERC Compliance <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a>
    </div>
  );
}

export default NCT;